<template lang="pug">
.new-order
  shForm(title="Nueva Orden Mayorista")
</template>

<script>
import shForm from '@/components/pages/orderWholesaler/Form'

export default {
  name: 'NewOrderWholesaler',

  components: { shForm }
}
</script>

<style lang="stylus">
.new-order
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/orderWholesaler/New.vue